const ApiService = Shopware.Classes.ApiService;

/**
 * 08/2023 created
 */
class TopdataPbCategoryExtensionApiService extends ApiService {

    /**
     * @param {Object} topdataPbCategoryExtension
     */
    updateTopdataPbCategoryExtension(topdataPbCategoryExtension) {
        const apiRoute = `topdata-product-boxes/update-topdata-pb-category-extension/${topdataPbCategoryExtension.id}`;
        return this.httpClient.put(apiRoute, topdataPbCategoryExtension, this._getDefaultOptions());
    }

    /**
     * Property groups that actually occur on active products of the category
     * (including sub-categories), sorted by number of products.
     *
     * @param {String} categoryId
     * @returns {Promise<Array<{id: String, name: String, productCount: Number}>>}
     */
    getPropertyGroupsOfCategory(categoryId) {
        const apiRoute = `topdata-product-boxes/property-groups-of-category/${categoryId}`;
        return this.httpClient.get(apiRoute, this._getDefaultOptions()).then((response) => {
            return response.data.payload;
        });
    }

    _getDefaultOptions() {
        return {
            headers: this.getBasicHeaders(),
            // version: Shopware.Context.api.apiVersion,
        };
    }
}

export default TopdataPbCategoryExtensionApiService;
